import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { resolve } from '@/infrastructure/container';
import { ud_di } from './di';
import { assertBootSubscribers } from './bootSubscribers';
import { type AppBus, TOKEN_IAppBus } from '@/services/AppBus';
import { AppView } from '@/views/AppView';
import { ErrorBoundaryView } from '@/views/ErrorBoundaryView';
import { TOKEN_AppStore } from '@/views/AppStore';
import { TOKEN_ThemeStore } from '@/views/ThemeStore';
import { TOKEN_ToastStore } from '@/views/ToastStore';
import { TOKEN_PlayerStore } from '@/views/PlayerStore';
import { TOKEN_IAnalytics } from '@/services/Analytics';
import { TOKEN_II18n } from '@/services/i18n/I18n';

import './index.css';

async function boot(): Promise<void> {
  ud_di();

  // Resolve analytics early so its global error listeners attach before anything can throw.
  resolve(TOKEN_IAnalytics);

  // Load the browser-preferred locale before first paint, so the UI renders fully translated.
  await resolve(TOKEN_II18n).init();

  // Subscribers before any publisher: PlayerStore catches BOOK_LOADED / BOOK_CLEARED / KEY_DOWN,
  // ToastStore TOAST_REQUESTED, ThemeStore the 'd' shortcut.
  resolve(TOKEN_ThemeStore);
  resolve(TOKEN_ToastStore);
  resolve(TOKEN_PlayerStore);

  // Fail loud if a required subscriber was never wired, instead of dropping its events at runtime.
  assertBootSubscribers(resolve(TOKEN_IAppBus) as AppBus);

  // Publisher last: AppStore's constructor starts the keyboard listener.
  resolve(TOKEN_AppStore);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundaryView>
        <AppView />
      </ErrorBoundaryView>
    </StrictMode>,
  );
}

void boot();
